import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/HammerFill.tsx
const HammerFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M19.663 4.594a2 2 0 0 0-1.664-1.607l-3.165-.482a2 2 0 0 0-1.301.245L7.47 6.25a2 2 0 0 0-.776 2.652l-.412.238a2 2 0 0 0-2.685-.655l-.866.5a2 2 0 0 0-.732 2.732l1 1.732a2 2 0 0 0 2.732.732l.866-.5a2 2 0 0 0 .732-2.732l-.045-.078.408-.236.046.08a2 2 0 0 0 2.732.732l.013-.008v-.001l5.844-3.375.002.001 2.369-1.367a2 2 0 0 0 .965-2.103ZM16.556 8.931l-5.196 3 5.067 8.776a2 2 0 0 0 2.732.732l1.732-1a2 2 0 0 0 .732-2.732l-5.067-8.776Z",
		fill: props.fill || "currentColor"
	})
}));
export { HammerFillIcon };
